import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import { Talep } from 'src/model/talep';
import {Teklif} from '../model/teklif';
import {TeklifComponent} from '../teklif/teklif.component';

@Component({
  selector: 'app-teklif-liste',
  templateUrl: './teklif-liste.component.html',
  styleUrls: ['./teklif-liste.component.css']
})
export class TeklifListeComponent implements OnInit {

  DURUM_INITIAL = Teklif.DURUM_INITIAL;
  DURUM_CEVAPLANDI = Teklif.DURUM_CEVAPLANDI;
  DURUM_RED = Teklif.DURUM_RED;
  DURUM_IPTAL = Teklif.DURUM_IPTAL;
  DURUM_REVIZE_EDILDI = Teklif.DURUM_REVIZE_EDILDI;

  ACTION_INCELE = TeklifComponent.ACTION_INCELE;
  ACTION_TEKLIF_GIR = TeklifComponent.ACTION_TEKLIF_GIR;
  ACTION_TEKLIF_REVIZE = TeklifComponent.ACTION_TEKLIF_REVIZE;
  teklifler: Teklif[] = null;

  @Input()
  public set source(teklifler: Teklif[]) {
    if (teklifler != null) {
      this.teklifler = teklifler;
    }
  }

  constructor(private router: Router) {
  }

  ngOnInit(): void {
  }

  incele(t: Teklif, actionParam: string = this.ACTION_INCELE) {
    this.router.navigate(['teklif'], {queryParams: {id: t.id, action: actionParam}});
  }

}

